import { ProdcutCreateComponent } from './product-create.component';

export default ProdcutCreateComponent;
